import { render } from "./TransportSettings.vue?vue&type=template&id=07d2b546&ts=true"
import script from "./TransportSettings.vue?vue&type=script&lang=ts"
export * from "./TransportSettings.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__